"use strict";

import Mustache from "mustache";
import { toggle } from '@nt-workspace/common';

let reviews: Reviews = {

  reviewsSection: null,
  reviewsListSection: null,
  reviewsOptions: {
    productId: null,
    familyCode: null,
    language: null,
    page: 1,
    rating: 'all',
    orderBy: 'newest-first',
  },
  writeReviewForm: null,
  hasNextPage: false,
  ratingFilters: [],
  loadMoreReviews: null,
  orderBySelect: null,
  reviewsContainer: null,
  reviewsStates: [],
  reviewFormStates: [],
  writeReviewFormFields: null,
  previousReviewsOptions: null,
  ajaxBaseUrl: "/stage-ajax/reviews-v2",
  reviewsTemplate: null,
  reviewsState: null,
  reviewFormState: null,
  votedReviewIds: [],
  toggles: [],

  setReviewsRatingFilter(rating: string) {
    // Rating could be a number as a string
    // Parse and validate if it's 1-5 or default to 'all'
    const parsedRating =
      [1, 2, 3, 4, 5].indexOf(parseInt(rating)) > -1 ? parseInt(rating) : "all";
    // If rating will change...
    if (this.reviewsOptions.rating !== parsedRating) {
      this.setReviewsPage(1);
      this.reviewsOptions.rating = parsedRating.toString();
    }
    // Unselect rating filters, select this rating filter
    this.ratingFilters.forEach((i) =>
      i.dataset.reviewsFilterRating == parsedRating.toString()
        ? i.classList.add("is-toggled")
        : i.classList.remove("is-toggled")
    );
  },

  setReviewsOrderBy(orderBy) {
    // If order will change...
    if (this.reviewsOptions.orderBy !== orderBy) {
      this.setReviewsPage(1);
      this.reviewsOptions.orderBy = orderBy;
    }
  },

  setReviewsPage(type) {
    if (type === "next") {
      this.reviewsOptions.page += 1;
    } else {
      this.reviewsOptions.page = 1;
    }
  },

  setState(reviewsState) {
    this.reviewsState = null;
    this.reviewsStates.forEach((state) => {
      if (state.dataset.reviewsState !== reviewsState) {
        state.style.display = "none";
      } else if (state.dataset.reviewsState === reviewsState) {
        this.reviewsState = state;
        state.style.display = "block";
      }
    });
  },
  getReviews() {
    var self = this;
    if (
      JSON.stringify(this.previousReviewsOptions) ===
      JSON.stringify(this.reviewsOptions)
    ) {
      // Reviews options has not changed
      console.log("Get reviews: no changes.");
      return false;
    }

    // Update previous review options
    this.previousReviewsOptions = Object.assign({}, this.reviewsOptions);

    this.setState("is-loading");

    // Get reviews by options
    var ajaxUrl = encodeURI(
      this.ajaxBaseUrl +
      "/get-reviews" +
      "?stage-language=" +
      this.reviewsOptions.language +
      "&productId=" +
      this.reviewsOptions.productId +
      "&rating=" +
      this.reviewsOptions.rating +
      "&orderBy=" +
      this.reviewsOptions.orderBy +
      "&page=" +
      this.reviewsOptions.page +
      (this.reviewsOptions.familyCode
        ? "&familyCode=" + this.reviewsOptions.familyCode
        : "")
    );

    if (this.reviewsOptions.page === 1 && this.reviewsContainer) {
      this.reviewsContainer.innerHTML = "";
    }

    try {
      fetch(ajaxUrl, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((reviews) => {
          // Render reviews markup
          var reviewsMarkup = Mustache.render(self.reviewsTemplate || '', {
            reviews: reviews,
          });

          // Clear reviews container if page is 1
          if (self.reviewsOptions.page === 1 && self.reviewsContainer) {
            // Append new reviews into container
            self.reviewsContainer.innerHTML = reviewsMarkup;
          } else {
            const lastChild = self.reviewsContainer?.lastElementChild;
            lastChild?.insertAdjacentHTML("afterend", reviewsMarkup);
          }
          self.hasNextPage = reviews.info.hasNextPage;

          if (self.hasNextPage) {
            self.setState("has-more-reviews");
          } else if (reviews.items.length === 0) {
            self.setState("has-no-reviews");
          } else {
            self.setState("has-no-more-reviews");
          }

          // Add toggle event listeners to new toggle elements
          this.reviewsListSection?.querySelectorAll(".js-toggle:not(.reviews-close)").forEach((el) => {
            toggle.initToggle(el as HTMLElement);
          });
        })
        .catch((err) => {
          console.log(err);
          console.log("Error getting reviews.");
          self.setState("has-error");
        });
      return true;
    } catch (err) {
      console.log(err);
      if (err instanceof Error && err.name !== "AbortError") {
        console.log("Error getting reviews.");
        self.setState("has-error");
      }
    }
  },

  setReviewUsefulness(reviewId, useful) {
    var self = this;

    if (!reviewId || ["yes", "no"].indexOf(useful) === -1) {
      console.log("Invalid or missing parameters:", reviewId, useful);
      return false;
    }

    if (this.isReviewVoted(reviewId)) {
      console.log("Already voted review usefulness:", reviewId);
      return false;
    }

    self.setReviewAsVoted(reviewId, useful);

    var ajaxUrl = encodeURI(
      this.ajaxBaseUrl +
      "/set-review-usefulness" +
      "?stage-language=" +
      this.reviewsOptions.language +
      "&reviewId=" +
      reviewId +
      "&useful=" +
      useful
    );

    try {
      fetch(ajaxUrl, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            console.log(
              "Error in voting review usefulness:",
              reviewId,
              useful,
              response
            );
          } else {
            console.log("Review usefulness successfully voted:", useful);
          }
        })
        .catch((err) => {
          console.log("Error getting reviews.");
          self.setState("has-error");
        });
      return true;
    } catch (err) {
      console.log("Error sending usefulness data.");
      return false;
    }
  },

  setReviewAsVoted(reviewId, vote) {
    if (!reviewId) {
      return;
    }
    if (this.votedReviewIds.indexOf(reviewId) === -1) {
      this.votedReviewIds.push(reviewId);
      var review = this.reviewsContainer?.querySelector(
        `[data-review-id="${reviewId}"]`
      );
      if (review) {

        review.classList.add("review--voted");
        review.classList.add(`review--voted--${vote}`);
        review.querySelectorAll("[data-review-useful]").forEach((el) => {
          el.setAttribute("disabled", "true");
        });
        var voteCount = review.querySelector(
          "[data-review-useful=" + vote + "] ~ [data-review-vote-count]"
        );
        var voteCountVal = voteCount ? parseInt(voteCount?.textContent || '') : 0;
        if (voteCount && !isNaN(voteCountVal)) {
          voteCount.textContent = (voteCountVal + 1).toString();
        }
      }
    }
  },

  isReviewVoted(reviewId) {
    return this.votedReviewIds.indexOf(reviewId) > -1 ? true : false;
  },

  setWriteReviewFormState(reviewFormState, fields) {
    var self = this;
    // Hide all states
    this.reviewFormState = null;
    this.reviewFormStates.forEach((state) => {
      state.style.display = "none";
    });

    // Set and show requested state
    var reviewFormStateEl = document.querySelector(
      "[data-review-form-state=" + reviewFormState + "]"
    );

    if (reviewFormStateEl) {
      this.reviewFormState = reviewFormState;
      (reviewFormStateEl as HTMLElement).style.display = "block";
    }

    if (reviewFormState === "is-submitting") {
      this.writeReviewForm
        ?.querySelector("[data-review-submit-review]")
        ?.setAttribute("disabled", "true");
      return;
    }

    if (reviewFormState === "has-fatal-error") {
      return;
    }

    if (reviewFormState === "has-error") {
      // Remove all error classes, hide all errors
      this.writeReviewForm
        ?.querySelectorAll(".field-error")
        .forEach((el) => el.classList.remove("field-error"));
      this.writeReviewForm
        ?.querySelectorAll("[data-field-error]")
        .forEach((el) => ((el as HTMLElement).style.display = "none"));

      // Add error classes, show errors
      if (fields && fields.length && fields[0].name) {
        // fields[{name:'field name', code: 'error code', ...}]
        fields.forEach((field) => {
          var fieldBlock = this.writeReviewForm?.querySelector("[name=" + field.name + "]")?.closest("[data-field-block]");

          fieldBlock?.classList.add("field-error");
          const errorEl = fieldBlock?.querySelector("[data-field-error]");
          if (errorEl) {
            (errorEl as HTMLElement).style.display = "block";
          }

        });
      }

      this.writeReviewForm
        ?.querySelector("[data-review-submit-review]")
        ?.setAttribute("disabled", "false");
      return;
    }

    if (reviewFormState === "is-submitted" && this.writeReviewFormFields) {
      this.writeReviewFormFields.style.display = "none";
      return;
    }
  },

  submitReview() {
    var self = this;

    if (!this.writeReviewForm) return false;
    const formData = new FormData(this.writeReviewForm);
    var ajaxUrl = encodeURI(
      this.ajaxBaseUrl +
      "/submit-review" +
      "?stage-language=" +
      this.reviewsOptions.language
    );

    // Validate fields

    this.setWriteReviewFormState("is-submitting");

    // For debugging
    /* self.setWriteReviewFormState("has-error", [
      { name: "username", code: "EXISTS" },
      { name: 'rating', code: 'RATING_MISSING_OR_INVALID'},
      { name: "reviewText", code: "REVIEW_TEXT_MISSING_OR_TOO_SHORT" },
      { name: "reviewTitle", code: "REVIEW_TITLE_MISSING_OR_TOO_LONG" },
    ]); */

    try {
      fetch(ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            console.log("Error in submitting review:", response);
            self.setWriteReviewFormState("has-error", response.fields);
          } else {
            if (typeof window.ga !== "undefined") {
              if (window.location.host.indexOf("admin.stage") > 0) {
                console.log("GA pageview not triggered in admin.");
              } else {
                window.ga(
                  "send",
                  "pageview",
                  location.pathname + "kiitos-" + document.documentElement.lang
                );
              }
            }
            console.log("Review submitted successfully.");
            self.setWriteReviewFormState("is-submitted");
          }
        })
        .catch((err) => {
          console.log(err);

          self.setWriteReviewFormState("has-fatal-error");
          console.log("Error submitting review.");
        });
      return true;
    } catch (err) {
      console.log(err);
      self.setWriteReviewFormState("has-fatal-error");
      console.log("Error submitting review.");
      return false;
    }
  },

  init() {
    console.log("reviews-v2 init");
    var self = this;

    // dom elements
    this.loadMoreReviews = document.querySelector(
      "[data-reviews-get-next-reviews]"
    );
    this.reviewsSection = document.querySelector("[data-reviews]");
    this.reviewsListSection = document.querySelector('[data-reviews-list]');

    this.ratingFilters = document.querySelectorAll(
      "[data-reviews-filter-rating]"
    );
    this.orderBySelect = (document.querySelector("[data-reviews-order-by]") as HTMLSelectElement);
    this.reviewsContainer = document.querySelector("[data-reviews-container]");
    this.reviewsStates = document.querySelectorAll("[data-reviews-state]");
    this.reviewFormStates = document.querySelectorAll(
      "[data-review-form-state]"
    );
    this.writeReviewForm = (document.getElementById("write-review-form") as HTMLFormElement);
    this.writeReviewFormFields = document.getElementById(
      "write-review-form-fields"
    );

    this.reviewsTemplate =
      document.getElementById("reviews-template")?.innerHTML || null;

    this.toggles = document.querySelectorAll('[data-toggle-target="read-reviews"]');

    console.log(this.toggles);
    //
    // Set default reviews options based on dom element attributes or values
    //
    this.reviewsOptions.productId = this.reviewsSection?.dataset.productId || null; // Static
    this.reviewsOptions.familyCode = this.reviewsSection?.dataset.familyCode || null; // Static
    this.reviewsOptions.language = this.reviewsSection?.dataset.language || null; // Static
    this.reviewsOptions.page = this.reviewsSection?.dataset.page
      ? parseInt(this.reviewsSection.dataset.page)
      : this.reviewsOptions.page; // Static
    this.hasNextPage = this.reviewsSection?.dataset.hasNextPage === 'true' ? true : false; // Static
    if (this.ratingFilters) {
      this.setReviewsRatingFilter(
        [...this.ratingFilters].find((e) => e.classList.contains("selected"))
          ?.dataset.reviewsFilterRating || "all"
      );
    }
    this.setReviewsOrderBy(this.orderBySelect.value);

    //
    // Add event listeners
    //

    // Filter by rating elements click event handlers
    this.ratingFilters.forEach((filter) => {
      filter.addEventListener("click", function (evt) {
        evt.preventDefault();
        self.setReviewsRatingFilter(this.dataset.reviewsFilterRating || "all");
        self.getReviews();
      });
    });

    // Order by dropdown change event handler
    this.orderBySelect.addEventListener("change", function (evt) {
      evt.preventDefault();
      self.setReviewsOrderBy((evt.target as HTMLSelectElement)?.value || "newest-first");
      self.getReviews();
    });

    // Next page element click event handler
    this.loadMoreReviews?.addEventListener("click", function (evt) {
      evt.preventDefault();
      self.setReviewsPage("next");
      self.getReviews();
    });

    // Review usefulness elements click event handlers
    this.reviewsListSection?.addEventListener("click", function (evt) {
      if ((evt.target as HTMLElement).dataset.reviewUseful !== undefined) {
        evt.preventDefault();
        const reviewEl = (evt.target as HTMLElement)?.closest("[data-review-id]");
        const reviewId = (reviewEl as HTMLElement)?.dataset.reviewId;
        const reviewUsefulness = (evt.target as HTMLElement)?.dataset.reviewUseful;
        if (reviewId && reviewUsefulness) {
          self.setReviewUsefulness(
            reviewId,
            reviewUsefulness
          );
        }
      }
    });

    this.toggles.forEach((toggleEl) => {
      toggleEl.addEventListener("click", function (e) {
        self.scrollToReviews();
      });
    })

    // Submit review form submit event listener
    this.writeReviewForm?.addEventListener("submit", function (evt) {
      evt.preventDefault();
      self.submitReview();
    });

    //
    // Get first reviews
    //

    window.addEventListener("load", function (evt) {
      // Scroll to product review section if url contains hash to review navigation
      if (window.location.hash === "#product-review-navigation") {
        self.reviewsSection?.scrollIntoView({
          behavior: "auto",
          block: "start",
          inline: "nearest",
        });
      }
    });

    if (this.reviewsOptions.page === 1) {
      this.getReviews();
    } else if (self.hasNextPage) {
      self.setState("has-more-reviews");
    }

    this.setWriteReviewFormState("is-ready");
  },

  scrollToReviews() {
    const bounding = this.reviewsSection?.getBoundingClientRect();
    window.scrollTo({
      top: (bounding?.top || 0) + window.scrollY || 0,
      behavior: "smooth",
    });
  }
};

export interface Reviews {
  reviewsSection: HTMLElement | null;
  reviewsListSection: HTMLElement | null;
  reviewsOptions: {
    productId: string | null;
    familyCode: string | null;
    language: string | null;
    page: number;
    rating: string;
    orderBy: string;
  };
  writeReviewForm: HTMLFormElement | null;
  hasNextPage: boolean;
  ratingFilters: NodeListOf<HTMLElement> | never[];
  loadMoreReviews: HTMLElement | null;
  orderBySelect: HTMLSelectElement | null;
  reviewsContainer: HTMLElement | null;
  reviewsStates: NodeListOf<HTMLElement> | never[];
  reviewFormStates: NodeListOf<HTMLElement> | never[];
  writeReviewFormFields: HTMLElement | null;
  previousReviewsOptions: any;
  ajaxBaseUrl: string;
  reviewsTemplate: string | null;
  reviewsState: HTMLElement | null;
  reviewFormState: string | null;
  votedReviewIds: string[];
  toggles: NodeListOf<HTMLElement> | never[];
  setReviewsRatingFilter(rating: string): void;
  setReviewsOrderBy(orderBy: string): void;
  setReviewsPage(type: number | string): void;
  setState(reviewsState: string): void;
  getReviews(): void;
  setReviewUsefulness(reviewId: string, useful: string): boolean;
  setReviewAsVoted(reviewId: string, vote: string): void;
  isReviewVoted(reviewId: string): boolean;
  setWriteReviewFormState(reviewFormState: string, fields?: any): void;
  submitReview(): boolean;
  scrollToReviews(): void;
  init(): void;
}

declare global {
  interface Window {
    ga: any;
  }
}

export default reviews;
